import { Button } from 'components/Button';
import { CircleLoader } from 'components/CircleLoader';
import { IconProps } from 'components/Icons/IconProps';
import { styles } from './styles';

// Interface for component props
interface ComputeCardProps {
  id: string;
  title: string;
  viewUrl: string;
  icon?: React.FC<IconProps>;
  total?: number;
  cta: {
    label: string;
    action: () => void;
  };
  isLoading?: boolean;
  style?: React.CSSProperties;
}

const ComputeCard = ({ id, title, cta, total, viewUrl, isLoading, icon, style }: ComputeCardProps) => {
  const IconComponent = icon as React.FC<IconProps>;
  return (
    <div className={styles.container} style={style}>
      <div className={styles.content}>
        <div className="card-header">
          <h2>
            {title}
            {IconComponent && <IconComponent strokeWidth={1.25} size={28} />}
          </h2>
        </div>
        <a key={id} className="view-text-area" href={viewUrl}>
          {isLoading ? <CircleLoader size="large" /> : <span className="total">{total}</span>}
          <span className="view-text">View {title}</span>
        </a>
      </div>
      <div className={styles.footer}>
        <Button variant="tertiary" className="cta-button" size="md" onClick={cta?.action} role="button" tabIndex={0}>
          {cta.label}
        </Button>
      </div>
    </div>
  );
};

export default ComputeCard;
